module.exports = __webpack_public_path__ + "static/media/finalize_mark_ic.d70581d8.svg";